import { errorPlayerContainerNotCreated } from './errors';
export const playerDestroy = async (player) => {
    if (!player) {
        throw errorPlayerContainerNotCreated;
    }
    await player?.getAny().destroy();
};
